/**
 * Backwards-compatible redirect: `/profiles/firm-tabs/:kind` →
 * `/profiles/firm-tabs?type=<kind>`. Replaces the deleted per-kind list page,
 * keeps deep-links and bookmarks alive.
 */
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { ROUTES } from "@/routes";
import { isFirmTabKind } from "@/api/profiles/firmTabsService";

export function FirmTabsKindRedirect() {
  const { kind } = useParams<{ kind: string }>();
  const [search] = useSearchParams();

  if (!isFirmTabKind(kind)) {
    return <Navigate to={ROUTES.profiles.firmTabs} replace />;
  }

  // Preserve any query params (e.g. ?companyId=…) the user arrived with.
  const next = new URLSearchParams(search);
  next.set("type", kind);
  return <Navigate to={`${ROUTES.profiles.firmTabs}?${next.toString()}`} replace />;
}

export default FirmTabsKindRedirect;
